(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-get-competition-result-count.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-get-competition-result-count.js');
"use strict";

const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _React = React,
  useEffect = _React.useEffect;
const selectCompetitionResultCount = svs.components.marketplaceCompetition.services.selectors.competitionResultSelectors.selectCompetitionResultCount;
const fetchParticipantsForCompetition = svs.components.marketplaceCompetition.services.actions.competitionActions.fetchParticipantsForCompetition;
const useGetCompetitionResultCount = _ref => {
  let competitionId = _ref.competitionId,
    type = _ref.type;
  const dispatch = useDispatch();
  const totalCount = useSelector(state => selectCompetitionResultCount(state, competitionId, type));
  useEffect(() => {
    if (competitionId && !totalCount && totalCount === null) {
      dispatch(fetchParticipantsForCompetition({
        competitionId
      }));
    }
  }, [competitionId, totalCount, dispatch]);
  return totalCount;
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.useGetCompetitionResultCount', useGetCompetitionResultCount);

 })(window);